import { useQuestionnaireStore } from '../../../lib/QuestionnaireStore';

export const useQuestionnaireValidation = (
  keyForComponent?: string
): {
  errorMessage: string;
  isQuestionnaire: boolean;
} => {
  const [getError, formType] = useQuestionnaireStore(state => [
    state.getError,
    state.formType
  ]);
  const rawError = getError(keyForComponent ?? '');
  const message = rawError?.message ?? '';

  return {
    errorMessage: (() => {
      if (formType !== 'questionnaire' || !message.includes('{{field}}')) {
        return message;
      }
      const fieldLabel =
        rawError?.component?.label ?? rawError?.formattedKeyOrPath ?? '';
      return message.replaceAll('{{field}}', fieldLabel);
    })(),
    isQuestionnaire: formType === 'questionnaire'
  };
};
